import { render, staticRenderFns } from "./SwitchIcon.vue?vue&type=template&id=18669b5a&scoped=true"
var script = {}
import style0 from "./SwitchIcon.vue?vue&type=style&index=0&id=18669b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18669b5a",
  null
  
)

export default component.exports